import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const StationRepository = RepositoryFactory.get('RailwayRepository')['StationRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(StationRepository)

export const STORE_MODULE_NAME = 'station';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
